const scrollToTopOfElement = (ref: React.RefObject<HTMLDivElement>) => {
  const element = ref.current;

  if (element !== null && element.scrollTop > 0) {
    element.scrollTo(0, 0);
  }
};

export default scrollToTopOfElement;
